// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thumbnails_wrapper__1e_r9","thumb":"Thumbnails_thumb__3KkDL"};